import { Component } from '@angular/core';

@Component({
  selector: 'app-attendance-link',
  templateUrl: './attendance-link.component.html',
  styleUrls: ['./attendance-link.component.scss']
})
export class AttendanceLinkComponent {

}
